/** @jsxImportSource @emotion/react */
import React from 'react';
import styled from '@emotion/styled';

interface KpiCardProps {
  icon: React.ReactNode;
  value: string | number;
  label: string;
}

const Card = styled.div`
  background: #1f2937;
  border: 1px solid #374151;
  border-radius: 12px;
  padding: 20px 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 8px;
  min-width: 0;
`;

const IconWrapper = styled.div`
  color: #6ee7b7;
  display: flex;
  align-items: center;
  justify-content: center;
`;

const Value = styled.div`
  font-size: 28px;
  font-weight: 700;
  color: #f9fafb;
  line-height: 1.1;
  text-align: center;
`;

const Label = styled.div`
  font-size: 12px;
  color: #9ca3af;
  text-align: center;
  line-height: 1.4;
`;

function formatValue(value: string | number): string {
  if (typeof value === 'string') return value;
  if (Number.isInteger(value)) {
    return new Intl.NumberFormat('ru-RU').format(value);
  }
  return value.toFixed(2);
}

const KpiCard = React.memo(({ icon, value, label }: KpiCardProps) => {
  return (
    <Card>
      <IconWrapper>{icon}</IconWrapper>
      <Value>{formatValue(value)}</Value>
      <Label>{label}</Label>
    </Card>
  );
});

export default KpiCard;
